module.exports = __webpack_public_path__ + "loading.df78065449714249347a.svg";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/img/loading.svg
// module id = ../../../../../src-admin/assets/img/loading.svg
// module chunks = styles